var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('loader-state',{attrs:{"inline":"","size":_vm.speakersLoaderSize}}):_c('dense-user-list',{attrs:{"users":_vm.speakers}},[_vm._v(" "+_vm._s(_vm.$t('lms.user.speakers'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }